import { takeLatest, put, call } from "redux-saga/effects";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

import {
  FETCH_BANKS_REQUEST,
  FETCH_BANKS_SUCCESS,
  FETCH_BANKS_FAILURE,
  SAVE_BANK_REQUEST,
  SAVE_BANK_SUCCESS,
  SAVE_BANK_FAILURE,
  CHANGE_BANK_STATUS_REQUEST,
  CHANGE_BANK_STATUS_SUCCESS,
  CHANGE_BANK_STATUS_FAILURE,
} from "./actionTypes";

function* fetchBanksSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(
      post,
      process.env.REACT_APP_GET_MASTER_BANKLIST,
      formData
    );

    yield put({ type: FETCH_BANKS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Fetch Banks Error:", error);
    yield put({
      type: FETCH_BANKS_FAILURE,
      payload: error.message,
    });
  }
}

function* saveBankSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_MASTER_BANKLIST,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save bank!");
    }

    yield put({ type: SAVE_BANK_SUCCESS, payload: response });
    Swal.fire("Success", response.message, "success");
  } catch (error) {
    console.error("Save Bank Error:", error);
    yield put({ type: SAVE_BANK_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

function* changeBankStatusSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_STATUSCHANGE_BANKLIST,
      action.payload
    );

    const message = response?.message || response?.Msg || response?.msg;
    const isSuccess = response?.status === "Success" || response?.status === "success" || 
                      message?.includes("Successfully") || message?.includes("successfully");

    if (isSuccess) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: message || "Deleted successfully!",
      });
      yield put({ type: CHANGE_BANK_STATUS_SUCCESS, payload: response });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: message || "Failed to delete bank!",
      });
      yield put({ type: CHANGE_BANK_STATUS_FAILURE, payload: message });
    }
  } catch (error) {
    yield put({ type: CHANGE_BANK_STATUS_FAILURE, payload: error.message });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message,
    });
  }
}

export default function* bankMasterSaga() {
  yield takeLatest(FETCH_BANKS_REQUEST, fetchBanksSaga);
  yield takeLatest(SAVE_BANK_REQUEST, saveBankSaga);
  yield takeLatest(CHANGE_BANK_STATUS_REQUEST, changeBankStatusSaga);
}
